export default "__VITE_ASSET__Dq0e4coB__"